<template>
  <div class="profilo">
    <navbar v-model="sidebar"></navbar>
    <sidebar v-model="sidebar"></sidebar>
    <b-container class="box">
        <b-row>
            <b-col></b-col>
            <b-col cols="6" class="center">
                <div class="login-line"></div>
                <form class="form" v-on:submit.prevent="onSubmit()">
                    <h3>Cambia la password</h3>
                    <br>
                    <b-form-input class="login-input" type="password" v-model="oldPass" placeholder="Password attuale" :state="state.oldPass"></b-form-input>
                    <b-form-input class="login-input" type="password" v-model="newPass1" placeholder="Nuova password" :state="state.newPass1"></b-form-input>
                    <b-form-input class="login-input" type="password" v-model="newPass2" placeholder="Reinserisci la nuova password" :state="state.newPass2"></b-form-input>
                    <b-button type="submit" class="login-submit">Cambia Password</b-button>
                </form>
            </b-col>
            <b-col></b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import navbar from '@/components/navbar.vue'
import sidebar from '@/components/sidebar.vue'

export default {
  name: 'profilo',
  components: {
    sidebar,
    navbar
  },
  data() {
    return {
        oldPass: '',
        newPass1: '',
        newPass2: '',
        state: {
            oldPass: null,
            newPass1: null,
            newPass2: null,
        },
        sidebar: this.$sidebar
    }
  },
  methods: {
        onSubmit() {
            if(this.oldPass == '' || this.oldPass == this.newPass1 || this.oldPass == this.newPass2){
                this.state.oldPass = false
            }else
               this.state.oldPass = null 

            if(this.newPass1 == '' || this.newPass1 != this.newPass2 || this.oldPass == this.newPass1){
                this.state.newPass1 = false
            }else
                this.state.newPass1 = null

            if(this.newPass2 == '' || this.newPass1 != this.newPass2 || this.oldPass == this.newPass2){
                this.state.newPass2 = false
            }else
                this.state.newPass2 = null

            if(this.oldPass != '' && this.newPass1 != '' && this.newPass2 != '' &&
                this.newPass1 == this.newPass2 && this.oldPass != this.newPass1 && this.oldPass != this.newPass2){
                this.state.oldPass = null
                this.state.newPass1 = null
                this.state.newPass2 = null
                
                Vue.http.post(this.$hostlink+'user/reset', {oldPass: this.oldPass, newPass1: this.newPass1, newPass2: this.newPass2}, {credentials : true}).then(response => {
                    if(response.body.success){
                        Vue.notify({
                            group: 'global',
                            title: 'Cambio password effettuato',
                            text: 'Cambio della password eseguito con successo!',
                            type: 'success'
                        })
                        this.$router.push('/home')
                    }else{
                        Vue.notify({
                            group: 'global',
                            title: 'Errore durante il cambio della password',
                            text: response.body.msg,
                            type: 'error'
                        })
                    }
                }, response => {
                    Vue.notify({
                        group: 'global',
                        title: 'Errore!',
                        text: 'Qualcosa è andato storto!',
                        type: 'error'
                    })
                })
            }else{
                Vue.notify({
                    group: 'global',
                    title: 'Errore durante il cambio della password',
                    text: 'Assicurati di aver inserito correttamente tutti i dati!',
                    type: 'error'
                })
            }
        }
    }
}
</script>
